import { render } from "./GeneratedInvoices.vue?vue&type=template&id=4f259526&scoped=true"
import script from "./GeneratedInvoices.vue?vue&type=script&lang=js"
export * from "./GeneratedInvoices.vue?vue&type=script&lang=js"

import "./GeneratedInvoices.vue?vue&type=style&index=0&id=4f259526&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f259526"]])

export default __exports__